<template>
  <div>
    <Layout>
      <PageHeader :title="'Satın Alma Sipariş Listesi'" :items="breadcrumbArray"></PageHeader>
      <v-app>
        <div class="row">
          <div class="col-lg-12">
            <Results :listType="'purchaseOrderList'"></Results>
          </div>
        </div>
      </v-app>

    </Layout>

  </div>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import Results from "@/components/orders/PurchaseOrders/Results.vue"


export default {
  page: {
    title: "Satın Alma Siparişleri",
    meta: [{name: "purchaseOrders", content: "Satın Alma Siparişleri"}],
  },
  components:{
    Layout,
    PageHeader,
    Results
  },
  data(){
    return {
      breadcrumbArray: [
        {
          text: "Siparişler",
          active: false,
        },
        {
          text: "Satın Alma Sipariş Listesi",
          active: true,
        },
      ],
    }
  },

  computed:{

  },
  methods:{

  }
}

</script>